module.exports = __webpack_public_path__ + "static/img/duijiang.d40607b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duijiang.png
// module id = i4ep
// module chunks = 24